module.exports = __webpack_public_path__ + "img/shaparak-new-version.ee4afa4d.png";